<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<section class="lease-endow" [hidden]="spinner">
  <header class="lease-endow--header">
    <div class="lease-endow--header__container">
      <h5 class="lease-endow--header__title">
        {{ 'reservationsVO' | i18next }}
      </h5>
      <div #stepperHeader></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestType"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
    (onCancel)="goHome()"
  ></app-stepper>
</section>
